// extracted by mini-css-extract-plugin
module.exports = {"comparisonCell":"az_jRc","cellText":"az_kRc"};